<template>
    <seccion-datos
        :titulo="accesousuario"
        tipo="secondary"
        @cambios="guardar($data)" 
    >
        <div style="display: grid; gap: 3px;">
            <div style="display: grid; grid-template-columns: repeat(5, 1fr) 0.5fr; gap: 2px;">
                <div style="display: flex;">
                    <p style="display: flex; margin-bottom: 0;">Nombre</p>
                </div>
                <div style="display: flex;">
                    <p style="display: flex; margin-bottom: 0;">Teléfono</p>
                </div>
                <div style="display: flex;">
                    <p style="display: flex; margin-bottom: 0;">Email</p>
                </div>
                <div style="display: flex;">
                    <p style="display: flex; margin-bottom: 0;">Nuevo usuario</p>
                </div>
                <div style="display: flex;">
                    <p style="display: flex; margin-bottom: 0;">Clave</p>
                </div>
                <div style="display: flex;">
                </div>
            </div>
            <div style="display: grid; grid-template-columns: repeat(5, 1fr) 0.5fr; gap: 2px;">
                <div style="display: flex;">
                    <input type="text" class="form-control form-control-sm" v-model="anadir_nombre">
                </div>
                <div style="display: flex;">
                    <input type="text" class="form-control form-control-sm" v-model="anadir_telefono">
                </div>
                <div style="display: flex;">
                    <input type="text" class="form-control form-control-sm" v-model="anadir_email">
                </div>
                <div style="display: flex;">
                    <input autocomplete="username" type="text" class="form-control form-control-sm" v-model="anadir_user">
                </div>
                <div style="display: flex;">
                    <input autocomplete="new-password" type="password" class="form-control form-control-sm" v-model="anadir_clave">
                </div>
                <div style="display: flex;">
                    <button class="btn btn-sm btn-secondary" @click="agregarUsuario()">Agregar</button>
                </div>
            </div>
            <div v-for="usuario in usuarios" style="display: grid; gap: 1px;" :key="usuario.idusuario">
                <div style="display: grid; grid-template-columns: 1fr 1fr 3fr 0.5fr; gap: 2px; margin-top: 2px;">
                    <div style="display: flex; align-items: center; background-color: #BCBCBC;">
                        <p style="margin-bottom: 0;">{{ usuario.nombre_completo }}</p>
                    </div>
                    <div style="display: flex; align-items: center; background-color: #BCBCBC;">
                        <p style="margin-bottom: 0;">{{ usuario.telefono_asociado }}</p>
                    </div>
                    <div style="display: flex; align-items: center; background-color: #BCBCBC;">
                        <p style="margin-bottom: 0;">{{ usuario.direccion_mail_usuario }}</p>
                    </div>
                    <div style="display: flex; align-items: center; background-color: #BCBCBC;">
                    </div>
                </div>
                <div style="display: grid; grid-template-columns: repeat(5, 1fr) 0.5fr; gap: 2px;">
                    <div style="display: flex; align-items: center; background-color: gainsboro;">
                    </div>
                    <div style="display: flex; align-items: center; background-color: gainsboro;">
                    </div>
                    <div style="display: flex; align-items: center; background-color: gainsboro;">
                    </div>
                    <div style="display: flex; align-items: center; background-color: gainsboro;">
                        <input disabled autocomplete="username" type="text" class="form-control form-control-sm" v-model="usuario.nombre">
                    </div>
                    <div style="display: flex; align-items: center; background-color: gainsboro;">
                        <input disabled autocomplete="username" type="password" class="form-control form-control-sm" v-model="usuario.contraseña">
                    </div>
                    <div style="display: flex; justify-content:center; align-items: center; background-color: gainsboro;">
                        <button class="btn btn-xs btn-secondary" @click="eliminarUsuario(usuario)">Eliminar</button>
                    </div>
                </div>
            </div>
        </div>
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
export default {
    props: {
        datos: {
            type: Object,
        },       
    },
    inject: ['guardar'],
    data() {
        return {
            usuarios:[],
            usuario_web: null,
            clave_web: null,
            accesousuario:'Acceso usuario',
            anadir_clave:'',
            anadir_user: '',
            anadir_email: '',
            anadir_telefono: '',
            anadir_nombre: '',
        }
    },
    watch: {
        datos() {
            this.init();
        }
    },
    methods: {
        async eliminarUsuario(usuario){
            const api = new PwgsApi();
            try{
                await api.delete('usuarios/' + usuario.idusuario);
                this.init();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async agregarUsuario(){
            const api = new PwgsApi();
            if(this.anadir_user == '' || this.anadir_clave == ''){
                alert('Debes introducir nombre de usuario y contraseña');
                return;
            }
            try{
                await api.post('usuarios', {
                    companyias_idcompanyia: this.datos.idcompañia,
                    nombre_completo: this.anadir_nombre,
                    telefono_asociado: this.anadir_telefono,
                    direccion_mail_usuario: this.anadir_email,
                    nombre: this.anadir_user,
                    contraseña: this.anadir_clave,
                });
                this.anadir_clave = '';
                this.anadir_user = '';
                this.anadir_email = '';
                this.anadir_telefono = '';
                this.anadir_nombre = '';
                this.init();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
            
        },
        async init() {
            const api = new PwgsApi();
            var usuarios = await api.get('companias/' + this.datos.idcompañia + '/usuario');
            usuarios = usuarios.datos.filter(usuario => usuario.nombre != '' && usuario.contraseña != '');
            this.usuarios = usuarios;
            console.log('usuarios', usuarios);
        },
    },
    created() {
        this.init();
    },
}
</script>